<template>
  <div>
    <el-row>
      <el-col :span="24"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  data () {
    return {}
  }
}
</script>

<style scoped>
a {
    text-decoration: none;
    color:black;
}
.copyright {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter/AppFooter.vue